import React from 'react';
import { API as API_BASE_FULL } from '../../../lib/api';
import { isSubscriptionErr } from '../billing/shared';

export const API = API_BASE_FULL;

export const formatErr = (detail) => {
  if (detail == null) return 'Something went wrong.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

// A locked (unpaid) workshop already gets one global toast with a Reactivate
// action from TenantContext, so swallow the duplicate here. Note this module's
// `formatErr` takes the response *detail*, while `notifyErr` takes the error.
export const notifyErr = (e) => {
  if (isSubscriptionErr(e)) return;
  alert(formatErr(e?.response?.data?.detail) || e?.message || 'Something went wrong.');
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const inputCls =
  'w-full bg-slate-950/60 border border-white/10 rounded-lg px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-teal-400 focus:ring-1 focus:ring-teal-400 transition';

export const Field = ({ label, required, children }) => (
  <label className="block">
    <span className="text-xs uppercase tracking-wider text-slate-400">
      {label}{required && <span className="text-red-400">*</span>}
    </span>
    <div className="mt-1.5">{children}</div>
  </label>
);

export const StatTile = ({ label, value, accent = 'text-teal-300', testid }) => (
  <div className="bg-white/5 border border-white/10 rounded-xl px-5 py-4" data-testid={testid}>
    <div className="text-xs uppercase tracking-wider text-slate-400">{label}</div>
    <div className={`text-2xl font-semibold mt-1 ${accent}`}>{value}</div>
  </div>
);
